import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchInputProps {
  defaultValue?: string;
  placeholder?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onSearched?: () => void;
}

export default function SearchInput({
  defaultValue = '',
  placeholder = '搜索黄金行情、投资资讯…',
  size = 'md',
  className = '',
  onSearched,
}: SearchInputProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
    onSearched?.();
  };

  const sizeClass =
    size === 'lg'
      ? 'h-12 pl-12 pr-28 text-base'
      : size === 'sm'
        ? 'h-10 pl-10 pr-20 text-sm'
        : 'h-11 pl-11 pr-24 text-sm';

  const iconClass = size === 'lg' ? 'left-4 text-lg' : size === 'sm' ? 'left-3 text-base' : 'left-3.5 text-base';

  return (
    <form onSubmit={handleSubmit} className={`relative w-full ${className}`} role="search">
      <span className={`pointer-events-none absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-foreground-400 ${iconClass}`}>
        <i className="ri-search-line" aria-hidden="true"></i>
      </span>
      <input
        type="search"
        name="q"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="站内搜索"
        className={`w-full rounded-full border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 outline-none transition-all focus:border-primary-400 focus:ring-2 focus:ring-primary-200 ${sizeClass}`}
      />
      <button
        type="submit"
        className="absolute right-1 top-1/2 flex -translate-y-1/2 items-center gap-1 rounded-full bg-primary-500 px-4 py-2 text-xs font-medium text-foreground-950 transition-colors hover:bg-primary-400 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-search-line" aria-hidden="true"></i>
        <span className="hidden sm:inline">搜索</span>
      </button>
    </form>
  );
}